import styled from 'styled-components';

export const Description = styled.p`
  width: 100%;
  margin-top: 8px;
  padding: 0 1rem;
  color: #432726;
  text-align: center;
  text-shadow: none;
  line-height: 1.4;
  ${Styles.desktop`
    max-width: 30rem;
    padding: 0;
    margin-top: 0;
    text-align: left;
  `}
`;
